<app-alert type="error" [size]="size" [showIcon]="true">
  <span alertTitle data-test-id="alertTitle">
    @if (size === 'large') {
      {{ 'components.processError.title' | translate }}
    } @else {
      @if (processFailureReason) {
        {{
          `components.processError.errors.${processFailureReason.error}`
            | translate
        }}
      } @else {
        {{ 'components.processError.errors.generic' | translate }}
      }
    }
  </span>

  @if (size === 'large') {
    <div alertBody data-test-id="alertBody" class="w-full">
      <p class="mb-2">
        @if (processFailureReason) {
          {{
            `components.processError.errors.${processFailureReason.error}`
              | translate
          }}
        } @else {
          {{ 'components.processError.errors.generic' | translate }}
        }
      </p>
      <ng-container [ngTemplateOutlet]="message" />
    </div>
  } @else if (processFailureReason?.message) {
    <div alertBody data-test-id="alertBody" class="text-xs">
      <ng-container [ngTemplateOutlet]="message" />
    </div>
  }
</app-alert>

<ng-template #message>
  <p>
    @if (messageObject) {
      {{
        'components.processError.validationError.start'
          | translate
            : {
                count: messageObject.error_count,
              }
      }}
      <a
        class="underline"
        target="_blank"
        [ngClass]="{
          'font-bold': size !== 'small',
        }"
        [href]="messageObject.pre_signed_url"
        >{{ 'components.processError.validationError.here' | translate }}</a
      >.
      @if (size === 'large') {
        {{ 'components.processError.validationError.end' | translate }}
      }
    } @else if (processFailureReason?.message) {
      @if (size === 'large') {
        <pre class="py-2 text-sm whitespace-normal">{{
          processFailureReason?.message ?? '' | nl2br
        }}</pre>
      } @else {
        <a [title]="processFailureReason?.message">details</a>
      }
    }
  </p>
</ng-template>
